import React, { useRef } from 'react'
import Box from '@material-ui/core/Box'
import ReviewAndPay from './steps/review-and-pay'
import { CoachingCenterWaiver } from 'components/waivers'
import { useFormContext } from 'react-hook-form'
import ParticipantAndContactInformation from './steps/participant-and-contact-information'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const StepContent = ({
  activeStep,
  groupEvent,
  marketingOptInChecked,
  handleMarketingOptInChange,
  paymentRequired,
  setPaymentRequired,
  handleNext,
  handlePrev,
  shouldShowWaiver,
  steps,
  shouldFetchClientSecret,
  setShouldFetchClientSecret,
  onSubmit,
  onRegistrationFull,
}) => {
  const form = useFormContext()
  const stripePaymentFormRef = useRef(null)
  const stepName = steps[activeStep]?.name
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <>
      <Box
        display={stepName === 'Participant Information' ? 'flex' : 'none'}
        flexDirection={isMobile ? 'column-reverse' : 'row'}
        justifyContent="space-between"
        py={6}
        position="relative"
      >
        <ParticipantAndContactInformation
          groupEvent={groupEvent}
          marketingOptInChecked={marketingOptInChecked}
          handleMarketingOptInChange={handleMarketingOptInChange}
          paymentRequired={paymentRequired}
          setPaymentRequired={setPaymentRequired}
          steps={steps}
          activeStep={activeStep}
          handleNext={handleNext}
        />
      </Box>

      <Box display={stepName === 'Review & Pay' ? 'block' : 'none'}>
        <ReviewAndPay
          groupEvent={groupEvent}
          handleNext={handleNext}
          handlePrev={handlePrev}
          paymentRequired={paymentRequired}
          shouldFetchClientSecret={shouldFetchClientSecret}
          setShouldFetchClientSecret={setShouldFetchClientSecret}
          shouldShowWaiver={shouldShowWaiver}
          stripePaymentFormRef={stripePaymentFormRef}
          marketingOptInChecked={marketingOptInChecked}
          onRegistrationFull={onRegistrationFull}
        />
      </Box>

      <Box display={stepName === 'Waiver' ? 'block' : 'none'}>
        <CoachingCenterWaiver
          form={form}
          withBackButton={true}
          showWaiver={stepName === 'Waiver'}
          onBackButtonClick={handlePrev}
          onSubmit={() => {
            if (stripePaymentFormRef.current?.submitPayment) {
              return stripePaymentFormRef.current.submitPayment()
            } else {
              return onSubmit()
            }
          }}
        />
      </Box>
    </>
  )
}

export default StepContent
